<template>
    <fragment>
        <grid
            :id="gridId"
            :ref="gridId"
            :rowHeaders="gridProps.rowHeaders"
            :data="gridProps.data"
            :columns="gridProps.columns"
            :options="gridProps.options"
            :pageOptions="gridProps.pageOptions"
            :theme="gridProps.theme"
            :language="gridProps.language"
            @click="onClick"
            @check="onCheck"
            @uncheck="onUncheck"
            @dblclick="onDblclick"
            @expande="onExpande"
            @collapse="onCollapse"
            @selection="onSelection"
        />
    </fragment>
</template>

<script>
/* Toast Grid */
import 'tui-grid/dist/tui-grid.css'
import { Grid }                 from '@toast-ui/vue-grid'

import Vue                      from 'vue';
import { mapGetters }           from 'vuex';
import _                        from 'lodash';
import $                        from 'jquery';
import axios                    from 'axios';
import store                    from '@/vuex/store';
import SDLLocale                from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil }  from '@/utils';

/* 컴포넌트에서 사용할 스크립트 */
export default {
    name : 'ToastTreeGrid',
    props : {
        'gridId'        : { required : true },
        'columns'       : { type : Array, default : [] },
        'data'          : { type : Array, default : [] },
        'options'       : { type : Object },
        'pageOptions'   : { type : Object },
        'theme'         : { type : [String, Object], default: 'clean' },
        'language'      : { type : String, default : SDLUtil.getI18nLanguage() || 'en'},
        'click'         : { type : Function }
    },
    data() {
        return {

        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
        })
    },
    components: {
        'grid' : Grid
    },
    methods: {
        onClick(e) {
            // Occurs when a mouse button is clicked on the Grid.
            let rowData = this.$refs[this.gridId].invoke('getData');
        },
        onCheck(e) {
            // Occurs when a checkbox in row header is checked.
            let rowData = this.$refs[this.gridId].invoke('getData');
        },
        onUncheck(e) {
            // Occurs when a checkbox in row header is unchecked.
            let rowData = this.$refs[this.gridId].invoke('getData');
        },
        onDblclick(e) {
            // Occurs when a mouse button is double clicked on the Grid.
            let rowData = this.$refs[this.gridId].invoke('getData');
        },
        onExpande(e) {
            // Occurs when the row having child rows is expanded.
        },
        onCollapse(e) {
            // Occurs when the row having child rows is collapsed.
        },
        onSelection(e) {
            // Occurs when selecting cells.
        },
    },
    created() {
        Vue.$log.info("TOAST-TREE-GRID gridId => ", this.gridId);
        this.gridProps = {
            data: this.data,
            columns: this.columns,
            options: this.options,
            pageOptions: this.pageOptions,
            theme: {
                name: 'clean',
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    }
                },
            },
            language: this.language,
        };
    },
    mounted() {
        //
    }
};
</script>

<style scoped>
    /* scoped 사용시 해당 컨포넌트에서만 사용 */
</style>


<!--

   const grid = new tui.Grid({
      el: document.getElementById('grid'),
      data: treeData,
      rowHeaders: ['checkbox'],
      bodyHeight: 500,
      treeColumnOptions: {
        name: 'name',
        useCascadingCheckbox: true
      },
      columns: [
        {
          header: 'Name',
          name: 'name',
          width: 300
        },
        {
          header: 'Artist',
          name: 'artist'
        },
        {
          header: 'Type',
          name: 'type'
        },
        {
          header: 'Release',
          name: 'release'
        },
        {
          header: 'Genre',
          name: 'genre'
        }
      ]
    });

    grid.on('expand', ev => {
      const { rowKey } = ev;
      const descendantRows = grid.getDescendantRows(rowKey);

      console.log('rowKey: ' + rowKey);
      console.log('descendantRows: ' + descendantRows);

      if (!descendantRows.length) {
        grid.appendRow(
          {
            name: 'dynamic loading data',
            _children: [
              {
                name: 'leaf row'
              },
              {
                name: 'internal row',
                _children: []
              }
            ]
          },
          { parentRowKey: rowKey }
        );
      }
    });

    grid.on('collapse', ev => {
      const { rowKey } = ev;
      const descendantRows = grid.getDescendantRows(rowKey);

      console.log('rowKey: ' + rowKey);
      console.log('descendantRows: ' + descendantRows);
    });
  


-->


// WEBPACK FOOTER //
// src/skpComponents/common/ToastTreeGrid.vue